import { render, staticRenderFns } from "./BusMenu.vue?vue&type=template&id=5563c491"
import script from "./BusMenu.vue?vue&type=script&lang=js"
export * from "./BusMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports